import Vue from 'vue'
import axios from 'axios'
import { makeUrl, defineString, safeEscape,
  makeMarkedImageId, debug, makeCombinedValue } from '../components/globals'



const storeForm = {
  namespaced: true,

  state: {
    fields: {},
    images: [],
    markedImagesData: {version: '2'},
    options: {}, // options for selects
    consultSettings: {}, // consult type settings
    focusedField: '', // field that need to be focused to
    activeTab: 0, // active tab
    persistData: false,
    errorPatientId: false,
    accessionNumber: '',
    qrText: ''
  },

  getters: {
    fields: state => state.fields,
    fieldDataChanged: state => state.fieldDataChanged,

    persistData: state => state.persistData,

    dataStatus: state => state.dataStatus,
    images: state => state.images,

    safeField(state) {
      return function(fieldName) {
        debug('storeForm safeField: fieldName=' + fieldName);
        const fieldValue = state.fields[fieldName];
        return (fieldValue != undefined) ? fieldValue.trim() : '';
      }
    },


    dataFiles(state) {
      return state.images.filter(i => i.num == '')
    },


    options: state => state.options,
    consultingMds: state => state.options.consultingMds ? state.options.consultingMds : [],
    // consultingMds: function(state) {
    //   // => state.options.consultingMds ? state.options.consultingMds : [],
    //   var arrResult = [];
    //   for (var i=0; i<state.options.consultingMds.length; i++) {
    //     const item = state.options.consultingMds[i];
    //     arrResult.push({ value: item.name, html: '<i>HTML: ' + item.name + '</i>'})
    //   }
    //   return arrResult
    // },


    referringMds: state => state.options.referringMds ? state.options.referringMds : [],

    consultSettings: state => state.consultSettings,


    imageData(state) {
      return function(imageDescr, imageNum) {
        // state.images is an array of objects
        // return state.images
        //   .find(im => im.dicom_image_type == imageType && im.num == imageNum);
        return state.images
          .find(im => im.descr == imageDescr && im.num == imageNum); // ???
          // .find(im => im.object_id == imageDescr && im.num == imageNum);
      }
    },


    havePatientPhoto(state) {
      return function() {
        // state.images is an array of objects
        return state.images
          .find(im => im.uploadId == 'photo' && im.type == 'report');
          // .find(im => im.object_id == 'Patient photo' && im.type == 'report');
      }
    },


    singleImageData(state) {
      return function(objectId) {
        // debug('storeForm getter singleImageData: objectId=' + objectId);
        return state.images
          .find(im => im.objectId === objectId);
        // returns undefined if not found
      }
    },


    markedImagesData: state => state.markedImagesData,
    // consultUid: state => state.fields['suid'],
    // consultRequestUid: state => state.fields['ruid'],
    consultType(state) {
      const type = state.fields['ConsultType'];
      // debug('storeForm getter consultType: type=' + type);
      return (type !== undefined) ? type : ''
    },

    consultUid(state) {
      const suid = state.fields['suid'];
      // debug('storeForm getter consultUid: suid=' + suid);
      return (suid !== undefined) ? suid : ''
    },
    accessionNumber: (state) => state.accessionNumber,
    qrText: (state) => state.qrText,
    consultRequestUid: state => state.fields['ruid'],



    // test if this field is an array and it contains specified value
    fieldContainsValue(state) {
      return function(fieldName, testValue) {
        const arr = state.fields[fieldName];
        return arr && arr.constructor == Array && arr.indexOf(testValue) != -1;
      }
    },

    // test if this field has specified value
    fieldHasValue(state) {
      return (fieldName, testValue) => (state.fields[fieldName] === testValue)
    },


    focusedField(state) {
      return state.focusedField
    },

    activeTab(state) {
      return state.activeTab
    },


    errorPatientId: state => state.errorPatientId,
  },



// //////////////////////////////////////////////////////////////////////
  actions: {
    setPersistData({commit}, newPersistData) {
      debug('storeForm newPersistData');
      commit('SET_PERSIST_DATA', newPersistData)
    },


    setConsultType({commit}, newConsultType) {
      debug('storeForm setConsultType');
      commit('SET_CONSULT_TYPE', newConsultType)
    },


    setConsultUid({commit}, newConsultUid) {
      debug('storeForm setConsultUid');
      commit('SET_CONSULT_UID', newConsultUid)
    },


    setImagesData({commit}, newImagesData) {
      debug('storeForm setImagesData');
      commit('SET_IMAGES_DATA', newImagesData)
    },



    setFocus({commit}, fieldName) {
      debug('storeForm setFocus');
      commit('SET_FOCUSED_FIELD', fieldName)
    },


    setActiveTab({commit}, newTab) {
      debug('storeForm setActiveTab');
      commit('SET_ACTIVE_TAB', newTab)
    },


    setErrorPatientId({commit}, value) {
      commit('SET_VALUE', {name: 'errorPatientId', value: value})
    },


    increaseActiveTab({commit, state}) {
      debug('storeForm increaseActiveTab');
      commit('SET_ACTIVE_TAB', state.activeTab + 1)
    },


    decreaseActiveTab({commit, state}) {
      debug('storeForm decreaseActiveTab');
      commit('SET_ACTIVE_TAB', state.activeTab - 1)
    },




// data reset    
    resetData({commit}) {
      debug('storeForm resetData');
      commit('RESET_DATA');
      commit('FIELD_DATA_CHANGED', false);
    },







    // marked images!
    setMarkedImageData({commit, state}, data) {
      // use for initialization: existing data is deleted!
      // data: {x, y, num, type}
      // set single image data
      debug('setMarkedImageData');
      commit('SET_MARKED_IMAGE_DATA', data);

      // update composite field
      const mid = JSON.stringify(state.markedImagesData);
      commit('SET_FORM_FIELD', {name:'MarkedImagesData', value:mid});
    },


    // marked images!
    updateMarkedImageData({commit, state}, data) {
      // use for updating: existind data is preserved (updated)
      // data: {x, y, num, type}
      // set single image data
      debug('updateMarkedImageData');
      commit('UPDATE_MARKED_IMAGE_DATA', data);

      // update composite field
      const mid = JSON.stringify(state.markedImagesData);
      commit('SET_FORM_FIELD', {name:'MarkedImagesData', value:mid});
    },

    

    // upload data!
    setSingleImageData({commit}, data) {
      debug('storeForm setSingleImageData: data=' + JSON.stringify(data));
      commit('SET_SINGLE_IMAGE_DATA', data)
    },


    setPatientData({commit}, data) {
      debug('storeForm setPatientData: data=' + JSON.stringify(data));
      commit('SET_PATIENT_DATA', data)
    },



    deleteServerObject({state, commit}, objectId) {
      debug('storeForm deleteServerObject: objectId=' + objectId
        + ' suid=' + defineString(state.fields['suid']));

      return new Promise((resolve, reject) => {
        var singleObject = state.images
          .find(im => im.objectId === objectId);

        if (!singleObject) {
          debug('storeForm deleteServerObject: cannot find objectId=' + objectId);
          resolve('objectId not found') // no such object - ok
        }

        const url = makeUrl('service.cgi?del=file'
          + '&suid=' + safeEscape(state.fields.suid)
          + '&uid=' + safeEscape(singleObject.uid)
          + '&uploadId=' + safeEscape(singleObject.uploadId)
          + '&type=' + safeEscape(singleObject.type)
          + '&tmp='+ (new Date().getTime()));
        debug('storeForm deleteServerObject: URL=' + url);

        axios.get(url)
          .then(response => {
            debug('storeForm deleteServerObject: response: '+JSON.stringify(response.data));

            if (response.data.result != undefined && response.data.result == 'ok') {
              debug('storeForm deleteServerObject: success, update images data: objectId=' + objectId)

              commit('DELETE_SINGLE_IMAGE_DATA', objectId) // deletes item in images

              resolve(response)
            } else {
              var err = 'unknown error';
              if (response.data.error != undefined && response.data.error != '') {
                err = response.data.error
              }
              debug('storeForm deleteServerObject: error: ' + err)
              reject(err)
            }
          }, error => {
            debug('storeForm deleteServerObject: error')
            reject(error)
          }
        )
      })
    }, // deleteServerObject



    updateField({commit, state}, fieldData) {
      const oldValue = defineString(state.fields[fieldData.name]);
      if (oldValue !== fieldData.value) {
        commit('SET_FORM_FIELD', fieldData);
      }
    },



    updateFieldCertain({commit}, fieldData) {
      debug('storeForm updateFieldCertain: ' + JSON.stringify(fieldData));
      commit('SET_FORM_FIELD', fieldData);
    },


    setFormData({commit}, newData) {
      commit('SET_FORM_DATA', newData);
    },



    
    // should be moved to storeForm!
    loadConsultSettings({commit}, consultType) {
      debug('storeForm loadConsultSettings: consultType=' + consultType);
      consultType = defineString(consultType);
      let url = makeUrl('service.cgi?get=consult_settings&ct=' + consultType
        + '&tmp='+ (new Date().getTime()));

      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            // debug('storeConfig loadConsultSettings: success: '
            //   +JSON.stringify(response.data));
            debug('storeForm loadConsultSettings: success');
            commit('SET_CONSULT_SETTINGS', response.data);
            resolve(response)
          }, error => {
            debug('storeForm loadConsultSettings: error: '
              +JSON.stringify(error))
            reject(error)
          }
        )
      })
    },


  


    uploadConsultData({state, commit}, {fields, cancelToken}) {
      debug('storeForm uploadConsultData: suid=' + state.fields.suid);

      let postData = { //MEDWEB_SESSION_ID: SESSION_ID,
        suid: fields.suid,
        ruid: '', //state.fields.ruid,
        // draft: draft
      }

      let url = makeUrl('upload_consult.cgi?');
      debug('storeForm uploadConsultData: URL=' + url);

      // transporm field names
      for (var f in fields) {
        if (f == 'suid' || f == 'ruid') {
          continue;
        }
        postData['Field-' + f] = fields[f]
      }


      prepareData(postData);

      debug('storeForm uploadConsultData: POST: ' + JSON.stringify(postData))

      // var x = true;
      // if (x) {
      //   return
      // }

      // const prevConsultUid = defineString(fields['suid']);

      return new Promise((resolve, reject) => {
        axios.post(url, postData, {cancelToken: cancelToken})
          .then(response => {
            debug('storeForm uploadConsultData: server returned: '+JSON.stringify(response.data));

            var error = defineString(response.data.error);
            const newConsultUid = defineString(response.data.suid);

            if (error == '' && newConsultUid != '') {
              debug('storeForm uploadConsultData: OK, study UID=['+newConsultUid+']');
              // if (prevConsultUid == '') {
              //   debug('storeForm uploadConsultData: set consult uid field');
              // }

              const accessionNumber = defineString(response.data.accessionNumber);
              // commit('SET_ACCESSION_NUMBER', accessionNumber);
              commit('SET_VALUE', {name: 'accessionNumber', value: accessionNumber});
              commit('SET_VALUE', {name: 'qrText', value: defineString(response.data.qrText)});
              
              debug('storeForm uploadConsultData: accessionNumber=' + accessionNumber);

              resolve(response)
            } else {
              debug('storeForm uploadConsultData: error')
              reject(response)
            }
          }, error => {
            debug('storeForm uploadConsultData: error')
            reject(error)
          }
        )
      })
    }, // uploadConsultData


    loadOptions({commit}, params) {
      debug('storeForm loadOptions: consultType=' + params.consultType);
      let url = makeUrl('service.cgi?get=form_options'
        + '&consult_type=' + params.consultType
        + '&must_have_consmd=' + defineString(params.existingConsMd)
        + '&must_have_refmd=' + defineString(params.existingRefMd)
        + '&tmp='+ (new Date().getTime()));
      debug('storeForm loadOptions: URL=' + url);

      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            debug('storeForm loadOptions: success');
            // debug('storeForm loadOptions: success: '+JSON.stringify(response.data));

            // format consulting MDs depending on availability
            for (var i in response.data.consultingMds) {
              var consmd = response.data.consultingMds[i];
              if (consmd.avail_state == 'closed') {
                // consmd.html = '<span style="color:red">[x] text ' + consmd.full_name + '</span>';
                consmd.text = '[x] ' + consmd.full_name + ' -- Closed';
              } else {
                if (consmd.avail_state == 'out') {
                  // consmd.html = '<span style="color: blue">[!] text ' + consmd.full_name + ' (Out of Office)</span>';
                  consmd.text = '[!] ' + consmd.full_name + ' -- Out of Office';
                } else {
                  consmd.text = consmd.full_name;
                }
              }
            }


            commit('SET_FORM_OPTIONS', response.data)

            resolve(response)
          }, error => {
            reject(error)
          }
        )
      })
    },

    
    // ex getConsultUid
    loadConsultUid({commit}) {
      debug('storeForm loadConsultUid');
      let url = makeUrl('service.cgi?get=consultUid'
        + '&tmp='+ (new Date().getTime()));

      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            debug('storeConfig loadConsultUid: success: '
              +JSON.stringify(response.data));
            const uid = defineString(response.data.uid);
            if (uid != '') {
              commit('SET_CONSULT_UID', uid);
              resolve(response)
            } else {
              debug('storeForm loadConsultUid: Cannot get new consult UID');
              reject('Cannot get new consult UID');
            }
          }, error => {
            debug('storeForm loadConsultUid: error: '
              +JSON.stringify(error))
            reject(error)
          }
        )
      })
    },
    


  },






  mutations: {
    SET_FORM_OPTIONS(state, data) {
      debug('storeForm SET_FORM_OPTIONS: ' + JSON.stringify(data));
      Vue.set(state, 'options', data)
    },

    SET_CONSULT_SETTINGS(state, data) {
      debug('storeForm SET_CONSULT_SETTINGS: ' + JSON.stringify(data));
      Vue.set(state, 'consultSettings', data)
    },

    SET_CONSULT_UID(state, consultUid) {
      debug('storeForm SET_CONSULT_UID: consultUid=' + consultUid);
      Vue.set(state.fields, 'suid', consultUid)
    },



    SET_FORM_DATA(state, data) {
      debug('storeForm SET_FORM_DATA: ' + JSON.stringify(data));
      Vue.set(state, 'fields', data)
    },

    FIELD_DATA_CHANGED(state, flag) {
      debug('storeForm FIELD_DATA_CHANGED: flag=' + flag);
      state.fieldDataChanged = flag;
    },


    SET_IMAGES_DATA(state, data) {
      debug('storeForm SET_IMAGES_DATA: ' + JSON.stringify(data));
      Vue.set(state, 'images', data)
    },


    SET_FORM_FIELD(state, fieldData) {
      debug('storeForm SET_FORM_FIELD: ' + JSON.stringify(fieldData));
      Vue.set(state.fields, fieldData.name, fieldData.value);
    },


    SET_MARKED_IMAGE_DATA(state, data) {
        debug('storeForm SET_MARKED_IMAGE_DATA'
        + ': image_type=' + data.type
        + ', image_num=' + data.num
        + ', x=' + data.x
        + ', y=' + data.y);
      const image_key = makeMarkedImageId(data.type, '', data.num)
      state.markedImagesData[image_key] = {}; // reset existing data
      Vue.util.extend(state.markedImagesData[image_key], data);
    },


    UPDATE_MARKED_IMAGE_DATA(state, data) {
      debug('storeForm UPDATE_MARKED_IMAGE_DATA'
        + ': image_type=' + data.type
        + ', image_num=' + data.num
        + ', x=' + data.x
        + ', y=' + data.y);
      const image_key = makeMarkedImageId(data.type, '', data.num)
      if (state.markedImagesData[image_key] == undefined) {
        state.markedImagesData[image_key] = {};
      }
      Vue.util.extend(state.markedImagesData[image_key], data);
    },



    SET_SINGLE_IMAGE_DATA(state, data) {
      // debug('storeForm SET_SINGLE_IMAGE_DATA: data.objectId=' + data.objectId + ', uploadData=' + JSON.stringify(data.uploadData));
      debug('storeForm SET_SINGLE_IMAGE_DATA: data.objectId=' + data.objectId);

      for (var key in data) {
        debug('storeForm SET_SINGLE_IMAGE_DATA: --- data: [' + key + '] = ' + data[key]);
      }


      const indexFound = state.images
        .findIndex(im => im.objectId === data.objectId);
      
      if (indexFound >= 0) {
        debug('storeForm SET_SINGLE_IMAGE_DATA: found image by objectId: indexFound=' + indexFound);
        for (key in data) {
          if (key == 'objectId') continue;
          // debug('storeForm SET_SINGLE_IMAGE_DATA: update [' + key + '] = ' + data[key]);
          Vue.set(state.images[indexFound], key, data[key]); // nextTick ???
        }

        // Vue.util.extend(state.images[indexFound], data);
      } else {
        debug('storeForm SET_SINGLE_IMAGE_DATA: push new image, objectId=' + data.objectId);
        // new uploaded object
        state.images.push(data);
        // const newLength = state.images.push(data);
        debug('storeForm SET_SINGLE_IMAGE_DATA: PUSHED NEW !!!!!!!!!!!!!!!');
        // debug('storeForm SET_SINGLE_IMAGE_DATA: new images array length=' + newLength);
      }
    },



    SET_PATIENT_DATA(state, data) {
      debug('storeForm SET_PATIENT_DATA: data.objectId=' + data.objectId);

      for (var name in data) {
        debug('storeForm SET_PATIENT_DATA: --- data: [' + name + '] = ' + data[name]);
        Vue.set(state.fields, name, data[name]);
      }
    },




    DELETE_SINGLE_IMAGE_DATA(state, objectId) {
      debug('storeForm DELETE_SINGLE_IMAGE_DATA: objectId = ' + objectId);
      const foundIndex = state.images.findIndex(im => im.objectId === objectId);
      if (foundIndex >= 0) {
        state.images.splice(foundIndex, 1);
        debug('storeForm DELETE_SINGLE_IMAGE_DATA: objectId "' + objectId + '" deleted');
      } else {
        debug('storeForm DELETE_SINGLE_IMAGE_DATA: objectId "' + objectId + '" not found');
      }

      // for (var i=0; i<state.images.length; i++) {
      //   if (state.images[i].uploadId === uploadId) {
      //     state.images.splice(i, 1)
      //   }
      // }
    },

    

    SET_ALL_MARKED_IMAGES_DATA(state, data) {
      debug('storeForm SET_ALL_MARKED_IMAGES_DATA: ' + JSON.stringify(data));
      Vue.set(state, 'markedImagesData', {});
      Vue.util.extend(state.markedImagesData, data);
    },

    RESET_DATA(state) {
      debug('storeForm RESET_DATA begin');
      Vue.set(state, 'fields', {});
      Vue.set(state, 'images', []);
      Vue.set(state, 'markedImagesData', {version: '2'});
      Vue.set(state, 'options', {});
      Vue.set(state, 'consultSettings', {});
      debug('storeForm RESET_DATA end');
    },




    SET_FOCUSED_FIELD(state, fieldName) {
      state.focusedField = fieldName
    },

    SET_PERSIST_DATA(state, newPersistData) {
      state.persistData = newPersistData
    },

    SET_ACTIVE_TAB(state, newTab) {
      state.activeTab = newTab
    },

    SET_CONSULT_TYPE(state, newConsultType) {
      state.fields['ConsultType'] = newConsultType
    },

    SET_VALUE(state, {name, value}) {
      state[name] = value
    }

  },
}







// // utility functions
// function makeCombinedValue(arrValue, strValue) {
//   var result = '';
//   if (Array.isArray(arrValue)) {
//     result = arrValue.join('; ');
//   } else {
//     result = defineString(arrValue);
//   }
//   if (result != '') {
//     if (strValue != '') {
//       result += '; ' + strValue;
//     }
//   } else {
//     result = strValue;
//   }
//   return result;
// }




function prepareData(data) {
  debug('storeForm prepareData');
  const consultType = 'Dermatology';
  debug('storeForm prepareData: consultType = ' + consultType);
  data['Field-ConsultType'] = consultType;

  // split dob!
  const dob = defineString(data['Field-DOB']);
  var month = dob.substr(0, 2),
    day = dob.substr(3, 2),
    year = dob.substr(6, 4);
  data['Field-DOB_year'] = year;
  data['Field-DOB_month'] = month;
  data['Field-DOB_day'] = day;
  data['Field-DOB'] = ''; // delete
  debug('storeForm prepareData: year=' + data['Field-DOB_year']);

  // translate some field names
  // data['Field-derm_Reason'] = data['Field-ReasonForConsult'];
  // data['Field-ReasonForConsult'] = '';

  // data['Field-derm_Duration'] = data['Field-Duration'];
  // data['Field-Duration'] = '';

  // data['Field-derm_CurrentMedications'] = data['Field-CurrentMedications'];
  // data['Field-CurrentMedications'] = '';


  // combined fields
  data['Field-Symptoms'] = makeCombinedValue(data['Field-Symptoms'],
    data['Field-Symptoms_Other']);
  data['Field-Symptoms_Other'] = '';

  data['Field-BodyLocations'] = makeCombinedValue(data['Field-BodyLocations'],
    data['Field-BodyLocations_Other']);
  data['Field-BodyLocations_Other'] = '';

  data['Field-Allergies'] = makeCombinedValue(data['Field-Allergies'], data['Field-Allergies_Other']);
  data['Field-Allergies_Other'] = '';

  const patientType = defineString(data['Field-PatientType']);
  debug('__________ patientType = ' + patientType);

  if (patientType == 'new') {
    //
    data['Field-MedicalConditions'] = makeCombinedValue(data['Field-MedicalConditions'],
      data['Field-MedicalConditions_Other']);
    data['Field-MedicalConditions_Other'] = '';

    data['Field-SurgicalProcedures'] = makeCombinedValue(data['Field-SurgicalProcedures'],
      data['Field-SurgicalProcedures_Other']);
    data['Field-SurgicalProcedures_Other'] = '';

    data['Field-PersonalConditions'] = makeCombinedValue(data['Field-PersonalConditions'],
      data['Field-PersonalConditions_Other']);
    data['Field-PersonalConditions_Other'] = '';

    // convert single primary value to array for makeCombinedValue
    data['Field-Sunscreen'] = makeCombinedValue([data['Field-Sunscreen']], data['Field-Sunscreen_Spf']);
    data['Field-Sunscreen_Spf'] = '';
    
    // convert single primary value to array for makeCombinedValue
    data['Field-FamilyHistoryMelanoma'] = makeCombinedValue([data['Field-FamilyHistoryMelanoma']],
      data['Field-FamilyHistoryMelanoma_Relative']);
    data['Field-FamilyHistoryMelanoma_Relative'] = '';

    // convert single primary value to array for makeCombinedValue
    data['Field-FamilyHistoryCellCarcinoma'] = makeCombinedValue([data['Field-FamilyHistoryCellCarcinoma']],
      data['Field-FamilyHistoryCellCarcinoma_Relative']);
      data['Field-FamilyHistoryCellCarcinoma_Relative'] = '';

    data['Field-RecentConditions'] = makeCombinedValue(data['Field-RecentConditions'],
      data['Field-RecentConditions_Other']);
    data['Field-RecentConditions_Other'] = '';

    data['Field-Alerts'] = makeCombinedValue(data['Field-Alerts'], '');
  }





  // remove blank fields
  for (var f in data) {
    if (f == 'suid' || f == 'ruid') continue; // keep these fields even blank
    if (defineString(data[f]) === '') delete data[f];
  }  


  
  // // uniform chief complaint
  // data['Field-ChiefComplaint'] = getChiefComplaint(data);



  // SPECIAL FIELDS
  data['Report-Description'] = getReportTitle(data) + ' (portal)';
  data['Field-Modality'] = getModality(consultType);
  data['Study-Type'] = getStudyDescription(data);
  data['Report-Source'] = 'portal';
  data['Report-Subtype'] = 'portal';




  // // urgency
  // if (basicSettings['show_urgency_menu'] == '1'
  //     && !('Field-Urgency' in data)) {
  //   data['Field-Urgency'] = '0'; // need to reset Urgency value
  // }

}



// function getChiefComplaint(data)
// {
//   const consult_type = data['Field-ConsultType'];

//   var cc = '';
//   switch (consult_type) {
//     case 'General':
//       cc = data['Field-ChiefComplaint'];
//       break;
//     case 'Dental':
//       cc = data['Field-dental_Complaint'];
//       break;
//     case 'Dermatology':
//       cc = data['Field-derm_ChiefComplaint'];
//       if (cc == 'Other') cc = data['Field-derm_ChiefComplaint_Other'];
//       break;
//     case 'Stroke Evaluation':
//       cc = data['Field-neuro_ChiefComplaint'];
//       break;
//     case 'Wound Care':
//       cc = data['Field-wound_ChiefComplaint'];
//       break;
//     case 'Psychiatry':
//       //cc = getTextValue('m_psy_ChiefComplaint');
//       var cc1 = data['Field-psy_ChiefComplaint'];
//       var cc2 = data['Field-psy_ChiefComplaint_Specified'];
//       if (cc1 != '' && cc2 != '') cc = cc1 + ', ' + cc2;
//       else cc = cc1;
//       break;
//     case 'Einstein General':
//       cc = data['Field-ChiefComplaint'];
//       break;
//     default:
//       cc = defineString(data['Field-ChiefComplaint']);
//   }
//   return cc;
// }


function getReportTitle(data)
{
  var result = '';
  const consult_type = data['Field-ConsultType'];

  switch (consult_type) {
    case 'Stroke Evaluation':
      result = 'Stroke Evaluation Request';
      break;
    case 'Ophthalmology':
      if (defineString(data['Field-opht_CaseType']) == 'Neonatal') {
        result = 'Ophthalmology - ROP Consult Request';
      } else {
        result = 'Ophthalmology Consult Request';
      }
      break;
    case 'Dermatology':
      result = 'Dermatology Consult Request';
      break;
    case 'Dental':
      result = 'Dental Consult Request';
      break;
    case 'General':
      result = 'General Consult Request';
      break;
    case 'Wound Care':
      result = 'Wound Care Consult Request';
      break;
    case 'Psychiatry':
      result = 'Psychiatry Consult Request';
      break;
    case 'Triage':
      result = 'Triage Report';
      break;
    case 'Einstein General':
      result = 'Einstein General Consult Request';
      break;
    default:
      result = 'Consult Request';
  }

  return result;
}


function getModality(consult_type)
{
  const consult_type_lc = consult_type.toLowerCase();
  var modality = '';
  switch (consult_type_lc) {
    case 'general': modality = 'SC'; break;
    case 'dermatology': modality = 'DM'; break;
    case 'stroke evaluation': modality = 'SE'; break;
    case 'ophthalmology': modality = 'XC'; break; // was OP
    case 'cardiology': modality ='US'; break;
    case 'dental': modality ='DT'; break;
    case 'wound care': modality ='WC'; break;
    case 'psychiatry': modality ='PS'; break;
    case 'triage':
    case 'tictac':
    case 'brc': modality ='BM'; break;
    case 'einstein general': modality ='EN'; break;
    default: modality = 'SC';
  }
  return modality;
}


function getStudyDescription(data)
{
  const consult_type = data['Field-ConsultType'];
  
  if (consult_type == 'Ophthalmology'
      && defineString(data['Field-opht_CaseType']) == 'Neonatal') {
    return 'ophthalmology - ROP';
  } else {
    return consult_type.toLowerCase();
  }
}





export default storeForm